<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: 'App',
  data() {
    return {
    }
  },
  created() {
    setTimeout(() => {
      this.$translate.execute()
    }, 100)
  },
  methods: {
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
}

.el-dialog__header,
label {
  font-weight: 700;
}

.el-form,.el-dialog__body {
  .el-select {
    width: 100%;
  }
}

.tree-border {
  margin-top: 5px;
  border: 1px solid #e5e6e7;
  background: #FFFFFF none;
  border-radius: 4px;
}

.po-r {
  position: relative !important;
}

.po-a {
  position: absolute !important;
}

.btns{
  display: inline-block;
  .el-button{
    margin-right: 10px;
  }
}
</style>